import Box from '@/components/ui/Box'
import ProfileLastActivity from '@/components/profiles/ProfileLastActivity'

export default function ProfileActivity({ profile }) {
    const details = [
        ['Dernière activité', <ProfileLastActivity lastSeenAt={profile.last_seen_at} disabled={profile.disabled} emptyLabel="Pas encore enregistrée" />],
        ['Appareil / navigateur', profile.last_device],
    ]

    return (
        <Box title="Dernière activité">
            <dl className="flex flex-col gap-3 text-sm">
                {details.map(([label, value]) => (
                    <div key={label}>
                        <dt className="text-gray-500">{label}</dt>
                        <dd className="break-words">{value || 'Non disponible'}</dd>
                    </div>
                ))}
            </dl>
            <p className="text-xs text-gray-500 mt-4">
                Dernier appel à la fiche personnelle, enregistré au plus toutes les 5 minutes.
            </p>
        </Box>
    )
}
